import { DeliveryStatus } from '../../../../../../services/exports/Constants';

export default {
  title: 'Entregas externas',
  fields: {
    pickup: 'Recolha',
    dropoff: 'Entrega',
    status: 'Estado',
    estimated_time: 'Tempo estimado',
    actual_time: 'Tempo real',
    actions: 'Ações',
    time: 'Hora',
    pickup_estimate: 'Estimativa de recolha',
    dropoff_estimate: 'Estimativa de entrega',
  },
  labels: {
    pickup: 'Recolha',
    dropoff: 'Entrega',
  },
  delivery_statuses: {
    [DeliveryStatus.Pending]: 'Motorista pendente',
    [DeliveryStatus.RunnerAssigned]: 'Motorista atribuído',
    [DeliveryStatus.OnRoutePickup]: 'A caminho da recolha',
    [DeliveryStatus.ArrivedPickup]: 'Chegou ao local de recolha',
    [DeliveryStatus.PickedUp]: 'Recolhido',
    [DeliveryStatus.OnRouteDropoff]: 'A caminho da entrega',
    [DeliveryStatus.ArrivedDropoff]: 'Chegou ao local de entrega',
    [DeliveryStatus.Completed]: 'Concluído',
    [DeliveryStatus.Cancelled]: 'Cancelado',
  },
  buttons: {
    actions: 'Ações',
    open_tracking_url: 'Rastrear entrega',
    show_order_details: 'Ver detalhes do pedido',
    call_restaurant: 'Ligar ao restaurante',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
  },
};
